<template>
	<view style="overflow: hidden;" :style="{'background':data.config.containerBgColor ||'','border-radius':data.config.borderRadius+'px','color':data.config.textColor ||'','marginTop': data.config.marginTop+'px','marginRight': data.config.marginRight+'px', 'marginBottom': data.config.marginBottom+'px','marginLeft': data.config.marginLeft+'px','paddingTop': data.config.paddingTop+'px','paddingBottom': data.config.paddingBottom+'px','paddingLeft': data.config.paddingLeft+'px','paddingRight': data.config.paddingRight+'px'}">
		<uni-search-bar :bgColor="data.config.cardBgColor" :textColor="data.config.textColor" radius="5" placeholder="请输入内容" clearButton="always" cancelButton="always" @confirm="search"
						@cancel="cancel" />
	</view>
</template>

<script>
	export default {
		name: 'Tpl_Text',
		props: {
			data: {
				type: Object,
				default: () => ({})
			},
		},
		methods: {}
	};
</script>

<style scoped>
</style>